import {
  Card,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';
import { useCommonContext } from '../contexts/common-context';

interface ActiveOrdersLoadingProps {
  cardCount?: number;
}

export const ActiveOrdersLoading = ({ cardCount = 5 }: ActiveOrdersLoadingProps) => {
  const { isMobile } = useCommonContext();
  const visibleCards = Array.from({ length: Math.min(cardCount, 5) }, (_card, index) => index);
  const cardStyles = isMobile
    ? 'sui-min-w-[192px] sui-max-w-[192px] sui-min-h-[192px] sui-max-h-[192px]'
    : 'sui-min-w-[280px]';

  return (
    <div
      className="sui-flex sui-flex-nowrap sui-gap-4 sui-w-full sui-min-w-0 sui-overflow-hidden"
      data-testid="active-orders-loader"
    >
      {visibleCards.map((cardIndex) => (
        <Card
          key={`active-orders-loading-card-${cardIndex}`}
          className={`sui-rounded-lg sui-border-0 ${cardStyles}`}
        >
          <SkeletonContent orientation="vertical" disablePadding>
            <div className="sui-flex sui-flex-col sui-gap-2 sui-w-full" style={{ minHeight: 54 }}>
              <SkeletonLine variant="multi" />
            </div>
          </SkeletonContent>
          <div className="sui-flex sui-gap-2 sui-w-full sui-mt-1">
            {[1, 2, 3].map((imageIndex) => (
              <SkeletonBlock
                key={`active-orders-loading-image-${cardIndex}-${imageIndex}`}
                aspect="square"
                height={12}
                width={12}
              />
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
};

ActiveOrdersLoading.defaultProps = {
  cardCount: 5,
};
